import { createSelector } from 'reselect'
import {
  networkGroup,
} from './utils'

const config = state => state.admin.config
const editSlotWindowOpen = state => state.admin.editSlotWindowOpen
const emailAttachments = state => state.admin.emailAttachments
const updateConfigsResult = state => state.admin.updateConfigsResult
const searchResults = state => state.admin.searchResults
const moveCalendar = state => state.admin.moveCalendar
const moveBookingConfig = state => state.admin.moveCalendarConfig
const calendarCondensed = state => state.admin.calendarCondensed
const calendarSlotFilter = state => state.admin.calendarSlotFilter

const moveCalendarConfig = createSelector(
  moveBookingConfig,
  (config) => {
    return config && config.calendar_config ? config.calendar_config : {}
  }
)

const selectors = {
  config,
  editSlotWindowOpen,
  emailAttachments,
  updateConfigsResult,
  searchResults,
  moveCalendar,
  moveBookingConfig,
  moveCalendarConfig,
  calendarCondensed,
  calendarSlotFilter,
  ...networkGroup('admin', [
    'updateProject',
    'saveBookingform',
    'deleteBookingform',
    'updateSlotOverrides',
    'resetSlotOverrides',
    'updateSlotBlocked',
    'saveBooking',
    'deleteBooking',
    'loadEmailAttachments',
    'createEmailAttachment',
    'updateEmailAttachment',
    'deleteEmailAttachment',
    'search',
    'loadMoveCalendar',
    'loadMoveCalendarConfig',
  ])
}

export default selectors
